export default __webpack_public_path__ + "static/media/google-play-6647242_1280.a15410a5.jpg";